import { computed } from '@vue/composition-api'
import CollectionModule from '@/store/stores/collectionModule/CollectionModule'
import VideoPlatformContentsDocument from '@/store/stores/collectionModule/documents/videoPlatformContents/VideoPlatformContentsDocument'
import useVideoPlatformContentsParams from '@/store/hook/videoPlatformContents/useVideoPlatformContentsParams'

/**
 * ヘッドラインコンテンツを操作するための処理
 */
export default function useSfOfficialWebContents() {
  const sfOfficialWebCollectionModule = CollectionModule.createStore(VideoPlatformContentsDocument)
  const autoLinkSfOfficialWebCollectionModule = CollectionModule.createStore(
    VideoPlatformContentsDocument,
  )

  const { generateDisplayFilter } = useVideoPlatformContentsParams()

  /**
   * 管理者登録ヘッドラインコンテンツ情報一覧取得
   */
  const fetchAdminRegisterHeadlineContents = async () =>
    sfOfficialWebCollectionModule.fetch({
      query: {
        filter: {
          $and: [generateDisplayFilter(), { videoType: null }],
        },
        // 作成日時が新しい順にソートする
        sort: '-_createdDate',
      },
    })

  /**
   * 自動登録ヘッドライン情報一覧取得
   * - 最大10件まで表示するため、limit:10を指定している
   */
  const fetchAutoLinkSfOfficialWebContents = async () =>
    autoLinkSfOfficialWebCollectionModule.fetch({
      query: {
        filter: { videoType: 'autoLinkSfOfficialWeb' },
        // 作成日時が新しい順にソートする
        // 連携処理で記事の公開日時を開始日時にセットしている
        sort: '-startDate',
        limit: 10,
      },
    })

  /**
   * ヘッドライン、動画コンテンツ情報一覧
   */
  const adminRegisterSfOfficialWebContents = computed(() => sfOfficialWebCollectionModule.data)

  /**
   * 自動で登録されたヘッドライン情報一覧
   */
  const autoLinkSfOfficialWebContents = computed(() => autoLinkSfOfficialWebCollectionModule.data)

  /**
   * 取得したヘッドライン、動画コンテンツ情報をクリアする
   */
  const clearSfOfficialWebContents = () => {
    sfOfficialWebCollectionModule.clearData()
    autoLinkSfOfficialWebCollectionModule.clearData()
  }

  return {
    fetchAdminRegisterHeadlineContents,
    fetchAutoLinkSfOfficialWebContents,
    adminRegisterSfOfficialWebContents,
    autoLinkSfOfficialWebContents,
    clearSfOfficialWebContents,
  }
}
